import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn } from '@angular/router';
import { Apollo } from 'apollo-angular';
import { Observable, map, of } from 'rxjs';

import { noCacheQuery } from '../../../../utils/graphql.functions';
import { ScannerDraft } from '../../consts/scanner-results.utils';
import { GET_AWARD_REQUEST_DRAFT } from '../../services/scanner-draft.query';

export interface ScannerResolvedData {
  idDocAwarding: string | null;
  categoryCode: string | null;
  draft: ScannerDraft | null;
}

interface AwardRequestDraftResponse {
  main_doc_award_request_by_pk: {
    id: string;
    doc_processor_response: ScannerDraft | null;
    cls_category_award: { code: string } | null;
  } | null;
}

export const scannerDraftResolver: ResolveFn<ScannerResolvedData> = (
  route: ActivatedRouteSnapshot
): Observable<ScannerResolvedData> => {
  const id = route.queryParamMap.get('id');

  if (!id) {
    return of({ idDocAwarding: null, categoryCode: null, draft: null });
  }

  const apollo = inject(Apollo);

  return apollo
    .query<AwardRequestDraftResponse>(
      noCacheQuery({ query: GET_AWARD_REQUEST_DRAFT, variables: { id } })
    )
    .pipe(
      map(({ data }) => {
        const request = data.main_doc_award_request_by_pk;
        return {
          idDocAwarding: id,
          categoryCode: request?.cls_category_award?.code ?? null,
          draft: request?.doc_processor_response ?? null,
        };
      })
    );
};
